import { type BrandZohoTypes } from "@elit-hair/brands";
import { Icon, InitialsAvatar } from "@elit-hair/elit-ui";
import { t } from "i18next";
import { TbId, TbMail } from "react-icons/tb";

import { cn } from "@/lib/utils";
import { formatEmailForWrapping } from "@/utils/formatters";

type LastCallRecord = (BrandZohoTypes["Leads"] | BrandZohoTypes["Contacts"]) & { moduleType?: string };

type Props = {
    record: LastCallRecord | null;
};

export function LastCallRecordInfo({ record }: Props) {
    const moduleLabel = record?.moduleType ? record.moduleType.slice(0, -1) : undefined;
    const formattedEmail = formatEmailForWrapping(record?.Email);

    return (
        <div className="w-full">
            <div className="flex flex-col items-center gap-2 p-2 mt-2 rounded-md bg-muted/40 border border-secondary">
                <InitialsAvatar name={record?.Full_Name || ""} />
                <p className="text-sm text-center font-medium">{record?.Full_Name || t("no_data")}</p>
                <div className="flex flex-col min-w-0 w-full">
                    <div className="flex items-center gap-2 min-w-0">
                        {moduleLabel && (
                            <span
                                className={cn(
                                    "text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full",
                                    "bg-secondary text-muted-foreground"
                                )}
                            >
                                {moduleLabel}
                            </span>
                        )}
                    </div>
                    <div className="flex flex-col gap-1 text-xs text-muted-foreground w-full min-w-0">
                        <p className="flex items-center gap-1 text-left w-full min-w-0">
                            <Icon icon={TbId} />
                            <span className="truncate">
                                {t("id")}: {record?.id || t("no_data")}
                            </span>
                        </p>

                        <p className="flex gap-1 text-left w-full min-w-0">
                            <Icon icon={TbMail} className="mt-0.5" />
                            <span className="flex-1 break-words whitespace-pre-wrap" title={record?.Email || undefined}>
                                {formattedEmail || t("no_data")}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
